exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".touch-action-manipulation[data-v-c73009be] {\n  touch-action: manipulation;\n}\n.fade[data-v-c73009be] {\n  animation-name: oz-overlay-fade-c73009be;\n  animation-duration: 0.2s;\n  will-change: opacity;\n}\n@keyframes oz-overlay-fade-c73009be {\n0% {\n    opacity: 0;\n}\n100% {\n    opacity: 1;\n}\n}\n", ""]);

